<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="3000011" />

    <section slot="titleRight">
      <qx-permpisions permpisions="7000601">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="vehicleServiceBO.ajax?cmd=doQueryInsuranceList"
          :params="fullSearchData"
          bizName="车辆年审记录信息导出"
          bizCode="exp100052"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1002060101">
        <el-button type="primary" plain @click="() => toEdit(null, 'add')">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            :fixed="item.prop === 'plateNumber'"
          >
            <section slot-scope="scope">
              <section
                v-if="scope.column.property === 'plateNumber'"
                @click="toCarDetail(scope.row)"
              >
                <span class="primary cur">{{
                  scope.row[scope.column.property]
                }}</span>
              </section>
              <section v-else>
                <span>{{ scope.row[scope.column.property] }}</span>
              </section>
            </section>
          </el-table-column>
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="140"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :isCenter="true"
                :btnList="[
                  {
                    permpisions: '7000603',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row, 'edit'),
                  },
                  {
                    showCondition: true,
                    name: '查看',
                    event: () => toEdit(scope.row, 'detail'),
                  },
                  {
                    permpisions: '7000604',
                    showCondition: true,
                    name: '删除',
                    event: () => toDelete(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.id),
                  },
                ]"
              />
            </template>
          </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import LogRightDialog from 'components/logRightDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import {
  doQueryInsuranceList,
  doDelete,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    LogRightDialog,
    TableBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'licenceTypeName',
            label: '牌照类型',
          },
          {
            prop: 'vehicleInfo',
            label: '车型',
          },
          {
            prop: 'orgName',
            label: '归属部门',
          },
          {
            prop: 'relUserName',
            label: '归属员工',
          },
          {
            prop: 'linkman',
            label: '司机姓名',
          },
          {
            prop: 'mobilePhone',
            label: '司机手机',
          },
          {
            prop: 'certificatesInsuranceTypeName',
            label: '证照类型',
          },
          {
            prop: 'certificatesInsuranceFee',
            label: '金额',
          },
          {
            prop: 'insuranceStartDate',
            label: '生效时间',
          },
          {
            prop: 'insuranceEndDate',
            label: '到期时间',
          },
          {
            prop: 'inDay',
            label: '剩余天数',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryInsuranceList,
    toCarDetail (item) {
      if (item.licenceType < 3) {
        // 查看普通车辆详情
        const type = 'detail';
        this.jump({
          label: `查看车辆-${item.plateNumber}`,
          url: `/manage/car/archives/my/detailRecord?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass || ''}&type=${type}`,
          full: true,
        });
      } else {
        // 查看挂车详情
        this.jump({
          label: `查看挂车-${item.plateNumber}`,
          url: `/manage/car/trailer/archives/detail?id=${item.vehicleCode}&type=${''}`,
          full: true,
        });
      }
    },
    async toDelete (item) {
      const confirmRes = await this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await doDelete({ id: item.id });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '删除成功',
          });
          this.getData();
        }
      }
    },
    toEdit (item, type) {
      switch (type) {
        case 'add':
          this.jump({
            label: '新增证照登记',
            url: '/manage/car/maintain/review/edit',
            full: true,
          });
          break;
        case 'detail':
          this.jump({
            label: '查看证照登记',
            url: `/manage/car/maintain/review/detail?id=${item.id}&type=detail`,
            full: true,
          });
          break;
        case 'edit':
          this.jump({
            label: '修改证照登记',
            url: `/manage/car/maintain/review/edit?id=${item.id}`,
            full: true,
          });
          break;
        default:
          break;
      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
